import React, { useState, useEffect } from 'react';

import Pan1HNBADV from '../../layout/pan1HNBADV';
import Pan2HNBTools from '../../layout/pan2HNBTools';
import Pan3Menu from '../../layout/pan3CommunityMenu';
import Pan3MobileMenu from '../../layout/pan3CommunityMobileMenu';
import Pan4ADV from '../../layout/pan4ADV';

import WeeklyBest from './p5WeeklyBest';
import PostList from './p6CCList';

import Pan8Footer from '../../layout/pan8Footer/magazine';

import CustomTitle from '../../common/custom-title';

export default props=>{
    const [isMM, setMenu] = useState('block');
const jsx=(<div className="">
    {/* <CustomTitle subject="커뮤니티" /> */}
    <CustomTitle subject="" />
<style jsx>{`
.pan {
    padding-top:20px;
}


`}</style>
    <Pan1HNBADV />
    <div className="narrow-content">
        <Pan2HNBTools isCommunity showMenu={() => setMenu('block')} />
        <div className="dbom"><Pan3MobileMenu isCommunity /></div>
        <div className=""><Pan3Menu lookaround isMM={isMM} hideMobileMenu={() => setMenu('none')} /></div>

        <Pan4ADV />
        <div className="pan"><WeeklyBest lookaround /></div>
    </div>

    <div className="pan Pan6ArticleList"><PostList /></div>
    <Pan8Footer />
</div>);
    return jsx;
}
